<template>
  <div class="cabadmin-shell">
    <header class="cabadmin-header">
      <div class="header-left">
        <h1 class="cabadmin-title">{{ cabinet ? cabinet.name : 'Chargement…' }}</h1>
        <span v-if="cabinet" class="cabadmin-plan">{{ planLabel }}</span>
      </div>
      <div class="header-right">
        <SeatsCounter v-if="cabinet && !isOpenDomain" :used="cabinet.seats_used" :total="cabinet.seats || 0" />
      </div>
    </header>

    <div v-if="overCapacity" class="over-capacity-banner">
      <strong>Sièges dépassés.</strong>
      Vous utilisez plus de sièges que votre abonnement n'en autorise. Retirez des utilisateurs ou contactez Query Juriste.
    </div>

    <nav class="cabadmin-nav">
      <router-link :to="{ name: 'cabadmin-usage' }" class="nav-tab" active-class="active">Activité</router-link>
      <router-link v-if="!isOpenDomain" :to="{ name: 'cabadmin-users' }" class="nav-tab" active-class="active">Utilisateurs</router-link>
    </nav>

    <main class="cabadmin-content">
      <div v-if="error" class="error-state">{{ error }}</div>
      <router-view v-else-if="cabinet" :cabinet="cabinet" @refresh="loadCabinet" />
      <div v-else class="loading-state">Chargement…</div>
    </main>
  </div>
</template>

<script>
import { getCabinet } from '@/services/cabadmin';
import SeatsCounter from '@/components/cabadmin/widgets/SeatsCounter.vue';

export default {
  name: 'CabAdminLayout',
  components: { SeatsCounter },
  data() {
    return { cabinet: null, error: null };
  },
  computed: {
    planLabel() {
      if (!this.cabinet || !this.cabinet.plan) return '';
      const p = this.cabinet.plan;
      return p.charAt(0).toUpperCase() + p.slice(1);
    },
    overCapacity() {
      return this.cabinet && this.cabinet.seats > 0 && this.cabinet.seats_used > this.cabinet.seats;
    },
    isOpenDomain() {
      // En SSO open_domain l'accès est piloté par le domaine, pas par l'allowlist :
      // l'onglet Utilisateurs (gestion d'allowlist) n'a pas de sens → on le masque.
      return this.cabinet && this.cabinet.sso_mode === 'open_domain';
    }
  },
  async mounted() {
    await this.loadCabinet();
  },
  methods: {
    async loadCabinet() {
      try {
        this.error = null;
        this.cabinet = await getCabinet();
        // Accès direct par URL à /cabadmin/users sur un cabinet open_domain :
        // l'onglet est masqué, on renvoie vers Activité.
        if (this.isOpenDomain && this.$route.name === 'cabadmin-users') {
          this.$router.replace({ name: 'cabadmin-usage' });
        }
      } catch (e) {
        console.error('[CabAdminLayout] loadCabinet failed:', e);
        if (e.response?.status === 403) {
          this.error = "Vous n'avez pas les droits pour accéder à cette page.";
        } else {
          this.error = "Impossible de charger les informations du cabinet.";
        }
      }
    }
  }
};
</script>

<style scoped>
.cabadmin-shell {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 32px 64px;
  font-family: 'Roboto', sans-serif;
  color: #222;
}
.cabadmin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.header-left { display: flex; align-items: baseline; gap: 12px; }
.cabadmin-title { margin: 0; font-size: 24px; font-weight: 600; }
.cabadmin-plan { font-size: 12px; text-transform: uppercase; letter-spacing: 0.06em; color: #6c63ff; }
.over-capacity-banner {
  margin-top: 16px;
  padding: 12px 16px;
  background: #fff5f5;
  border: 1px solid #ffcdd2;
  border-radius: 6px;
  color: #c62828;
  font-size: 14px;
}
.cabadmin-nav {
  display: flex;
  gap: 4px;
  margin: 24px 0 16px;
  border-bottom: 1px solid #eee;
}
.nav-tab {
  padding: 8px 16px;
  color: #555;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 500;
}
.nav-tab.active { color: #6c63ff; border-bottom-color: #6c63ff; }
.nav-tab:hover { color: #222; }
.cabadmin-content { min-height: 400px; }
.loading-state, .error-state {
  padding: 48px 24px;
  text-align: center;
  color: #777;
}
.error-state { color: #c62828; }
</style>
